<template>
	<div>
		<div class="navbar">
			<div style="display: flex;align-items: center; color: #fff; font-weight: 600;font-size: 14px; width: 1500px;">
				<img 
					:src="systeminfo.logo ? systeminfo.logo : lockr_logo" 
					class="logo">
				<p style="font-weight: bold;font-size: 17px;color: #fff;margin-right: 50px;">{{systeminfo.name ? systeminfo.name : lockr_name}}
				</p>
				<div class="nav-items-container">
					<flexbox style="width: auto;">
						<router-link 
							v-for="(item, index) in items"
							:style="{ 'color' : item.type == navIndexChild ? '#ffd04b' : '#fff' }" 
							:to="item.path"
							:key="index" 
							class="nav-item" 
							@click.native="navItemsClick(item.type)">
							<i 
								:class="'wukong-' + item.icon"
								:style="{ 'color': item.type == navIndexChild ? '#ffd04b' : '#fff'}" 
								class="wukong"
								style="margin-right: 5px;" />
							<div class="nav-item-title">{{ item.title }}</div>
						</router-link>
					</flexbox>
				</div>
			
				<!-- 消息 -->
				<el-badge
					:value="unreadNums.allCount"
					:hidden="!unreadNums.allCount || unreadNums.allCount == 0"
					:max="99">
					<i
						class="wukong wukong-message"
						@click="checkMessageDetail(false)"/>
				</el-badge>
				<system-message
					:visibles.sync="sysMessageShow"
					:unread-nums="unreadNums"
					@update-count="sendSystemUnreadNum"/>

				<el-popover 
					:visible-arrow="false" 
					placement="bottom" 
					popper-class="no-padding-popover" 
					width="200"
					trigger="click">
					<div class="handel-items">
						<div 
							class="handel-item" 
							@click="handleClick('person')">
							<i class="wukong wukong-personcenter" />修改密码
						</div>
						<div 
							class="handel-item" 
							@click="handleClick('goout')">
							<i class="wukong wukong-goout" />退出登录</div>
					</div>
					<div 
						slot="reference" 
						class="user-container">
						<div style="color: #fff;margin-right: 5px;">
							{{userInfo ? userInfo.username : ''}}
						</div>
						<div v-photo="userInfo"
							v-lazy:background-image="$options.filters.filterUserLazyImg(userInfo ? userInfo.thumb_img : '')"
							:key="userInfo ? userInfo.thumb_img : ''" 
							class="user-img div-photo" />
						<i class="el-icon-caret-bottom mark" />
					</div>
				</el-popover>
			</div>
		</div>
		<!-- 新增公告栏 -->
		<div class="announcement-bar">
		    <div class="announcement-content" v-show="gonggao">
		        <el-alert
		            :title="'系统公告📢:'+ gonggao"
		            type="error">
		          </el-alert>
		    </div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { Loading } from 'element-ui'
	import Lockr from 'lockr'
	import { systemMessageUnreadCountAPI } from '@/api/common'
	import SystemMessage from './SystemMessage'
	import {crmGgGetoneAPI} from '@/api/setting/setting'

	export default {
		components: {
			SystemMessage
		},
		props: {
			navIndex: {
				type: [Number, String],
				default: 0
			}
		},
		data() {
			return {
				navIndexChild: Lockr.get('navIndexChild') ? Lockr.get('navIndexChild') : 0,
				lockr_name: Lockr.get('systeminfo').name,
				lockr_logo: Lockr.get('systeminfo').logo,
				showEditPassword: false,
				// 消息
				unreadNums: {
					allCount: 0,
					mediateCount: 0,
					lawCount: 0,
				},
				sysMessageShow: false,
				intervalId: null,
				//公告
				gonggao:""
			}
		},
		computed: {
			...mapGetters([
				'userInfo',
				'systeminfo',
				'navActiveIndex',
				'allAuth'
			]),
			items() {
				var tempsItems = []
				if(!this.allAuth) return
				if (this.allAuth.index && this.allAuth.index.index) {
					tempsItems.push({
						title: '系统首页',
						type: 0,
						path: '/index',
						icon: 'workbench'
					})
				}
				if (this.allAuth.customer && this.allAuth.customer.index) {
					tempsItems.push({
						title: '线索管理',
						type: 1,
						path: '/customer',
						icon: 'customer'
					})
				}
				if (this.allAuth.lawcase && this.allAuth.lawcase.index) {
					tempsItems.push({
						title: '案件管理',
						type: 2,
						path: '/lawcase',
						icon: 'project'
					})
				}
				if (this.allAuth.contract && this.allAuth.contract.index) {
					tempsItems.push({
						title: '顾问单位',
						type: 3,
						path: '/contract',
						icon: 'contract'
					})
				}
				if (this.allAuth.finance && this.allAuth.finance.index) {
					tempsItems.push({
						title: '财务汇总',
						type: 4,
						path: '/finance',
						icon: 'money'
					})
				}
				if (this.allAuth.event && this.allAuth.event.index) {
					tempsItems.push({
						title: '日程',
						type: 5,
						path: '/event',
						icon: 'schedule'
					})
				}
				if (this.allAuth.setting) {
					tempsItems.push({
						title: '系统管理',
						type: 6,
						path: '/setting',
						icon: 'systemconfig'
					})
				}
				return tempsItems
			}
		},
		mounted() {
			this.navIndexChild = this.navIndex
			// 获取消息数
			this.getSystemUnreadNum('visibles')
			//获取公告
			this.getGongGao()
			// 监听
			this.$bus.on('document-visibility', (state) => {
				this.getSystemUnreadNum(state)
			})
		},
		beforeDestroy() {
			this.$bus.off('document-visibility')
			if (this.intervalId) {
				clearInterval(this.intervalId)
				this.intervalId = null
			}
		},
		methods: {
			navItemsClick(type) {
				Lockr.set('navIndexChild', type)
				this.navIndexChild = type
				this.$store.commit('SET_NAVACTIVEINDEX', type)
				this.$emit('nav-items-click', type)
			},
			handleClick(type) {
				if (type === 'goout') {
					this.$confirm('退出登录？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						.then(() => {
							var loading = Loading.service({
								target: document.getElementById('#app')
							})
							this.$store
								.dispatch('LogOut')
								.then(() => {
									location.reload()
									loading.close()
								})
								.catch(() => {
									location.reload()
									loading.close()
								})
						})
						.catch(() => {})
				} else if (type === 'person') {
					// this.showEditPassword = true
					this.$emit('pop-click', type)
				}
			},
			
			
			/**
			 * 查看消息详情
			 */
			checkMessageDetail() {
				this.sysMessageShow = true
			},
			
			/**
			 * 获取公告
			 */
			getGongGao() {
				crmGgGetoneAPI()
					.then(res => {
						this.gonggao = res.data.content ? res.data.content :''
					})
					.catch(() => {
					})
			},
			
			/**
			 * 获取系统未读消息数
			 */
			getSystemUnreadNum(state) {
				if (this.intervalId) {
					clearInterval(this.intervalId)
					this.intervalId = null
				}
				if (state == 'visibles') {
					this.sendSystemUnreadNum()
					this.intervalId = setInterval(() => {
						this.sendSystemUnreadNum()
					}, 600000)
				}
			},
			
			sendSystemUnreadNum() {
				if (this.intervalId) {
					clearInterval(this.intervalId)
					this.intervalId = null
				}
				systemMessageUnreadCountAPI()
					.then(res => {
						this.unreadNums = res.data
						if(res.data.allCount > 0){
							this.sysMessageShow = true
						}
					})
					.catch(() => {
						if (this.intervalId) {
							clearInterval(this.intervalId)
							this.intervalId = null
						}
					})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.navbar {
		width: 100%;
		height: 50px;
		min-height: 50px;
		// background-color: rgb(255, 255, 255);
		display: flex;
		align-items: center;
		position: relative;
		padding: 0 30px;
		justify-content: center;
		background-color: #f36b6b;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 9999;

		.logo {
			width: 35px;
			height: 30px;
			display: block;
			flex-shrink: 0;
			margin-right: 5px;
		}

		.nav-items-container {
			flex: 1;
			display: flex;
			min-width: 500px;
			height: 100%;
			overflow-x: auto;
			line-height: 60px;
			font-size: 13px;
			justify-content: flex-start;
			padding-right: 25px;
		}

		.user-container {
			display: flex;
			align-items: center;
			flex-shrink: 0;
			cursor: pointer;

			.user-img {
				display: block;
				width: 32px;
				min-width: 32px;
				min-height: 32px;
				height: 32px;
				margin-right: 8px;
				border-radius: 50%;
			}

			.mark {
				font-size: 15px;
				color: #aaaaaa;
			}
		}

		.user-container:hover {
			.mark {
				color: #2486e4;
			}
		}
	}

	.nav-item {
		padding: 0 15px;
		display: flex;
		align-items: center;
		cursor: pointer;
		// color: #fff !important;
		font-weight: normal !important
	}

	.nav-item-img {
		width: 24px;
		height: 24px;
		display: block;
		margin-right: 5px;
	}
	
	.announcement-bar {
	    margin-top: 50px;
	    z-index: 9998; 
	}
	.announcement-content {
	    margin: 0 auto;
		width: 1550px;
	}

	.handel-items {
		padding: 10px 0 18px 0;

		.handel-item {
			padding: 5px 20px;
			font-size: 14px;
			color: #aaa;
			cursor: pointer;

			i {
				margin-right: 8px;
				font-size: 15px;
			}
		}

		.handel-item:hover {
			background-color: #f7f8fa;
			color: #3e84e9;
		}

		.handel-box {
			padding: 0 15px;

			.handel-button {
				width: 100%;
				border-radius: 4px;
				border-color: #009df0;
				background-color: #009df0;
			}
		}
	}

	.hr-top {
		margin-top: 8px;
		border-top: 1px solid #f4f4f4;
		padding-top: 3px;
	}

	.nav-lang {
		cursor: pointer;
		color: #888;
		padding: 20px;

		&:hover {
			color: #3e84e9;
		}

		&.active {
			font-weight: bold;
			color: #3e84e9;
		}
	}

	.auth-button {
		background: linear-gradient(to right, #d9ac7c, #c28e5c);
		color: white;
		padding: 5px 15px;
		font-size: 12px;
		height: 24px;
		outline: none;
		margin: 0;
		border: none;
		border-radius: 12px;
		transform: scale(0.9);
		margin-right: 15px;
		cursor: pointer;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.auth-content {
		text-align: center;
		color: #333;
		padding: 30px 20px;

		.title {
			font-size: 16px;
			font-weight: 600px;
		}

		.detail {
			transform: scale(0.9);
			margin-top: 8px;
			font-size: 12px;
			margin-bottom: 15px;
		}

		.phone {
			background: linear-gradient(to right, #f2dfb2, #e5c78a);
			border-radius: 4px;
			padding: 5px 17px;
			font-size: 12px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
			line-height: 17px;
		}
	}
	/deep/ .el-badge {
	    margin-right: 20px !important;
	}
	.wukong-message{
		color: #9da9c2;
		cursor: pointer;
		font-size: 20px;
	}
	.wukong-message:hover{
		color: #3E84E9;
		cursor: pointer;
		font-size: 20px;
	}
	.nav-item-title{
		font-size: 13px;
	}
</style>
